<div class="row">
  <div class="col-12">
    <h2>{{ 'Standard.Setup' | translate }}</h2>
    <hr />
  </div>
</div>

<div class="row">
  <div class="col-12 pt-4 pb-4 text-center" *ngIf="loading">
    {{ 'Standard.Loading' | translate }} {{ 'Standard.Settings' | translate | lowercase }} ...
  </div>
  <div class="col-12">
    <ul class="nav nav-pills" *ngIf="!loading">
      <li class="nav-item" [ngStyle]="{'order':headers.activities.sortOrder}" *ngIf="!data.activities.hide">
        <a class="nav-link" (click)="getActivityTypes(); data.view = 'activities'" [ngClass]="data.view == 'activities' ? 'active' : ''">{{ 'Header.Activities' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.channels.sortOrder}">
        <a class="nav-link" (click)="getCaseChannels(); data.view = 'channels'" [ngClass]="data.view == 'channels' ? 'active' : ''">{{ 'Dashboard.CaseChannel' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.departments.sortOrder}" *ngIf="!data.departments.hide">
        <a class="nav-link" (click)="data.view = 'departments'" [ngClass]="data.view == 'departments' ? 'active' : ''">{{ 'Departments.Title' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.offerRejections.sortOrder}">
        <a class="nav-link" (click)="getOfferRejections(); data.view = 'offerRejections'" [ngClass]="data.view == 'offerRejections' ? 'active' : ''">{{ 'Offers.OfferRejections' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.skills.sortOrder}">
        <a class="nav-link" (click)="data.view = 'skills'" [ngClass]="data.view == 'skills' ? 'active' : ''">{{ 'Users.Skills' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.offerProcurements.sortOrder}" *ngIf="has_tender">
        <a class="nav-link" (click)="getOfferProcurements(); data.view = 'offerProcurements'" [ngClass]="data.view == 'offerProcurements' ? 'active' : ''">{{ 'Standard.ProcurementTypes' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.offerEnterprise.sortOrder}" *ngIf="has_tender">
        <a class="nav-link" (click)="getEntrepriseTypes(); data.view = 'offerEnterprise'" [ngClass]="data.view == 'offerEnterprise' ? 'active' : ''">{{ 'Standard.EntrepriseTypes' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.standardTexts.sortOrder}">
        <a class="nav-link" (click)="getStandardTexts(); data.view = 'standardTexts'" [ngClass]="data.view == 'standardTexts' ? 'active' : ''">{{ 'Standard.StandardTexts' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.opMainteneceCategories.sortOrder}" *ngIf="has_ops">
        <a class="nav-link" (click)="getDVCategories(); data.view = 'opMainteneceCategories'" [ngClass]="data.view == 'opMainteneceCategories' ? 'active' : ''">{{ 'OpsAndMaintenance.Category' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.priorities.sortOrder}">
        <a class="nav-link" (click)="getPriorities(); data.view = 'priorities'" [ngClass]="data.view == 'priorities' ? 'active' : ''">{{ 'Standard.Priority' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.caseStages.sortOrder}">
        <a class="nav-link" (click)="getCaseStages(); data.view = 'caseStages'" [ngClass]="data.view == 'caseStages' ? 'active' : ''">{{ 'Standard.CaseStages' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.customerTags.sortOrder}">
        <a class="nav-link" (click)="getCustomerTags(); data.view = 'customerTags'" [ngClass]="data.view == 'customerTags' ? 'active' : ''">{{ 'Standard.CustomerTags' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.caseTags.sortOrder}">
        <a class="nav-link" (click)="getCaseTags(); data.view = 'caseTags'" [ngClass]="data.view == 'caseTags' ? 'active' : ''">{{ 'Standard.CaseTags' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.assetCategories.sortOrder}" *ngIf="has_assets">
        <a class="nav-link" (click)="getAssetCategories(); data.view = 'assetCategories'" [ngClass]="data.view == 'assetCategories' ? 'active' : ''">{{ 'Assets.AssetCategories' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.assetFields.sortOrder}" *ngIf="has_assets">
        <a class="nav-link" (click)="getAssetCustomFields(); data.view = 'assetFields'" [ngClass]="data.view == 'assetFields' ? 'active' : ''">{{ 'Assets.AssetFields' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.formChannels.sortOrder}">
        <a class="nav-link" (click)="getFormChannels(); data.view = 'formChannels'" [ngClass]="data.view == 'formChannels' ? 'active' : ''">{{ 'Standard.FormChannels' | translate }}</a>
      </li>
      <li class="nav-item" [ngStyle]="{'order':headers.assetModels.sortOrder}">
        <a class="nav-link" (click)="getAssetModels(); data.view = 'assetModels'" [ngClass]="data.view == 'assetModels' ? 'active' : ''">{{ 'Standard.AssetModels' | translate }}</a>
      </li>
    </ul>
    <hr>
  </div>
</div>

<div class="row" *ngIf="data.view != '' && data.view != 'opMainteneceCategories' && data.view != 'formChannels' && data.view != 'assetModels'">
  <div class="col-6 mt-5">
    <div class="input-group align-item-center">
      <div class="input-group-prepend">
        <div class="input-group-text">{{ 'Buttons.AddNew' | translate }}</div>
      </div>
      <input #NewItemToAdd id="NewItemToAdd" type="text" class="form-control" />
      <select #newItemToAddSelector id="newItemToAddSelector" [(ngModel)]="data.assetFields.new.typeId" class="form-control" *ngIf="data.view == 'assetFields'">
        <option value="f7bcf698-b090-44c3-a9a8-10fde72e7282">Nummer</option>
        <option value="27e3ae4d-3a11-44be-884b-1e264176049e">Valg</option>
        <option value="ff07e38b-1905-479f-836f-1e648bc14e54">Tekst</option>
        <option value="71b6ab58-9d86-4b85-99eb-26a5db0cbbb2">Mere Tekst</option>
        <option value="515e2ba9-bb53-4860-966d-669c4af1fa7c">Dato og tid</option>
        <option value="ffbfd192-be48-4306-8a00-743a56708167">Dato</option>
        <option value="f21df8df-a7eb-43b9-a25b-99704d70c96c">Ja/Nej</option>
      </select>
      <button class="btn btn-success ml-3" (click)="contentCreate(NewItemToAdd.value, null)">{{ 'Buttons.Create' | translate }}</button>
    </div>
  </div>
  <div class="col-6 mt-5" *ngIf="data.view == 'standardTexts'">
    <div class="input-group align-item-center">
      <div class="input-group-prepend">
        <div class="input-group-text">{{  'Standard.Name' | translate }}</div>
      </div>
      <input #NewItemToBeAdded id="NewItemToBeAdded" type="text" class="form-control" />
      <button class="btn btn-success ml-3" (click)="contentCreate(NewItemToBeAdded.value, 'html')">{{ 'Buttons.Create' | translate }}</button>
    </div>
  </div>
</div>

<div class="row mt-3" *ngIf="data.view == 'standardTexts'">
  <div class="col-6">{{ 'Standard.Message' | translate }}</div>
  <div class="col-6">{{ 'Offer.OfferDescription' | translate }} / {{ 'Standard.AgreementNote' | translate }} /{{ 'Package.Prerequisites' | translate }}</div>
</div>

<!--Activities-->
<div class="row mt-3" *ngIf="data.view == 'activities'">
  <div class="col-6">
    <div class="listItem d-flex align-items-center transition" *ngFor="let x of data.activities.list; let i = index" [ngStyle]="{'order':x.sort}">
      <div class="col-1 listIcon" (click)="iconChanger = x" data-toggle="modal" data-target="#iconChangerModal"><i [ngClass]="x.icon"></i></div>
      <div class="col-7 textItem">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <div></div>
        <div></div>
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<!-- AssetFields -->
<div class="row mt-3" *ngIf="data.view == 'assetFields'">
  <div class="col-6">
    <div class="listItem d-flex align-Items-center" *ngFor="let x of data.assetFields.list; let i = index" style="height:auto;">
      <asset-custom-field [customField]="x" class="w-100" [editable]="true"></asset-custom-field>
      <div class="form-check ml-2">
        <input class="form-check-input mt-2" type="checkbox" [(ngModel)]="x.showOnAssetSite" (change)="updateShowOnAssetSite(x)">
        <label class="form-check-label text-nowrap mt-1">{{ 'Assets.ShowOnAssetSite' | translate }}</label>
      </div>
      <span class="text-danger cursor-pointer ml-2" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal"><i class="fas fa-trash-alt"></i></span>
    </div>
  </div>
</div>

<!--Channels-->
<div class="row mt-3" *ngIf="data.view == 'channels'">
  <div class="col-6">
    <div class="listItem d-flex align-items-center" *ngFor="let x of data.channels.list">
      <div class="col-1 listIcon" (click)="iconChanger = x" data-toggle="modal" data-target="#iconChangerModal"><i [ngClass]="x.icon"></i></div>
      <div class="col-7 textItem">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<!--Form Channels-->
<div class="row mt-3" *ngIf="data.view == 'formChannels'">
  <div class="col-6">
    <div class="listItem d-flex align-items-center" *ngFor="let x of data.formChannels.list">
      <div class="col-6 textItem">
        {{ x.formName }}
      </div>
      <div class="col d-flex justify-content-end">
        <select [(ngModel)]="x.caseChannelId" class="form-control" (change)="updateFormChannels(x.id, x.formId, x.caseChannelId)">
          <option [ngValue]="null">{{ 'Standard.None' | translate }}</option>
          <option *ngFor="let v of channelDropDown" value="{{v.id}}">{{ v.name }}</option>
        </select>
      </div>
    </div>
    <div *ngIf="!!data.formChannels.list && data.formChannels.list.length == 0">
      {{ 'Standard.NoChannelsCreated' | translate }}.
    </div>
  </div>
</div>

<!--Form Models and Types-->
<div class="row mt-3" *ngIf="data.view == 'assetModels'">
  <div class="col-12 col-md-8">
    <div class="d-flex justify-content-between">
      <button class="btn btn-sm btn-success" data-toggle="modal" data-target="#newAssetModelType" (click)="addModelOrType('Model')">{{ 'Buttons.AddAssetModel' | translate }}</button>
      <div class="w-25" *ngIf="!!data.allAssetModels && data.allAssetModels.length > 0">
        <input type="text" class="form-control form-control-sm" id="searchModels" (keyup)="searchModels()" placeholder="Søg">
      </div>
      <div class="form-check mr-5" *ngIf="!!data.allAssetModels && data.allAssetModels.length > 0">
        <input class="form-check-input mt-2" type="checkbox" id="ShowDeletedModels" (click)="filterAllModels()">
        <label class="form-check-label" for="ShowDeletedModels">
          {{ 'Standard.ShowDeletedModels' | translate }}
        </label>
      </div>
    </div>
    <div *ngIf="!!data.allAssetModels && data.allAssetModels.length == 0">
      {{ 'Standard.NoAssetModelsCreated' | translate }}.
    </div>
    <div *ngIf="!!data.assetModels && data.assetModels.length > 0">
      <table class="table table-striped table-hover table-sm" aria-label="Asset models">
        <thead>
          <tr>
            <th scope="col">{{ 'Asset.AssetCategory' | translate }}</th>
            <th scope="col">{{ 'Asset.Model' | translate }}</th>
            <th scope="col">{{ 'Standard.Type' | translate }}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let x of data.assetModels">
            <td>{{ x.model.categoryName }}</td>
            <td>{{ x.model.modelName }}</td>
            <td>{{ x.type.name }}</td>
            <td class="text-right" *ngIf="x.isActive">
              <span class="mr-3" data-toggle="modal" data-target="#editAssetModelType" (click)="editModelOrType(x, 'Model')" title="{{ 'Word.Edit' | translate }}"><i class="fas fa-pencil"></i></span>
              <span class="ml-3" (click)="modelIsActive(x, false)" title="{{ 'Standard.Remove' | translate }}"><i class="fas fa-trash-alt"></i></span>
            </td>
            <td class="text-right" *ngIf="!x.isActive">
              <span class="ml-3" (click)="modelIsActive(x, true)" title="{{ 'Standard.Recover' | translate }}"><i class="fas fa-trash-restore"></i></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <button class="btn btn-sm btn-success" data-toggle="modal" data-target="#newAssetModelType" (click)="addModelOrType('ModelType')">{{ 'Buttons.AddAssetType' | translate }}</button>
    <div *ngIf="!!data.assetModelTypes && data.assetModelTypes.length == 0">
      {{ 'Standard.NoAssetModelTypesCreated' | translate }}.
    </div>
    <div *ngIf="!!data.assetModelTypes && data.assetModelTypes.length > 0">
      <table class="table table-striped table-hover table-sm" aria-label="Asset model types">
        <thead>
          <tr>
            <th scope="col">{{ 'Standard.Type' | translate }}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let x of data.assetModelTypes">
            <td>{{ x.name }}</td>
            <td class="text-right">
              <span class="mr-3" data-toggle="modal" data-target="#editAssetModelType" (click)="editModelOrType(x, 'ModelType')" title="{{ 'Word.Edit' | translate }}"><i class="fas fa-pencil"></i></span>
              <span class="ml-3" (click)="removeModelType(x)"><i class="fas fa-trash-alt" title="{{ 'Standard.Remove' | translate }}"></i></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!--Departments-->
<div class="w-100 d-flex mt-3" *ngIf="data.view == 'departments'">
  <div class="w-50">
    <div class="listItem d-flex align-items-center cursor-pointer" *ngFor="let x of data.departments.list" (click)="focus = x">
      <div class="col-1">
        <img class="imgMax" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ x.logo }}" alt="Department image" *ngIf="!!x.logo" />
      </div>
      <div class="col-4 textItem">
        <b>{{ x.name }}</b>
        <div *ngIf="!!x.departmentBelongToName" style="font-size:.6rem;">{{'Department.BelongsTo' | translate}}: {{x.departmentBelongToName}}</div>
      </div>
      <div class="col-5 d-flex hiddenSelector" style="font-size:.6rem;">
        <div class="w-50 d-flex flex-column">
          <div>{{ x.address }}</div>
          <div>{{ x.zipCode}}</div>
          <div>{{ x.city}}</div>
        </div>
        <div class="w-50 d-flex flex-column">
          <div>{{ x.phone }}</div>
          <div>{{ x.email }}</div>
          <div>{{ x.website }}</div>
        </div>
      </div>
      <div class="col-2 extraFunction">
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
  <div class="w-50 ml-3 mr-3 p-3 border bg-grey rounded" *ngIf="!!focus">
    <div class="w-100 flex-between-top">
      <table class="w-50 border-none" aria-label="Focused department">
        <thead>
          <th class="text-center">{{ 'Standard.Department' | translate }}</th>
        </thead>
        <tbody>
          <tr><td>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="focus.name" placeholder="{{ 'Standard.Name' | translate }}" title="{{ 'Standard.Name' | translate }}">
          </td></tr>
          <tr style="height:1rem;"></tr>
          <tr>
            <td><input type="text" class="form-control form-control-sm" [(ngModel)]="focus.address" placeholder="{{ 'Standard.Address' | translate }}" title="{{ 'Standard.Address' | translate }}"></td>
          </tr>
          <tr><td>
            <input type="text" class=" form-control form-control-sm" [(ngModel)]="focus.zipCode" placeholder="{{ 'Standard.Zipcode' | translate }}" title="{{ 'Standard.Zipcode' | translate }}">
          </td></tr>
          <tr><td>
            <input type="text" class=" form-control form-control-sm" [(ngModel)]="focus.city" placeholder="{{ 'Standard.City' | translate }}" title="{{ 'Standard.City' | translate }}">
          </td></tr>
          <tr style="height:1rem;"></tr>
          <tr><td>
            <input type="text" class=" form-control form-control-sm" [(ngModel)]="focus.phone" placeholder="{{ 'Standard.Phone' | translate }}" title="{{ 'Standard.Phone' | translate }}">
          </td></tr>
          <tr><td>
            <input type="text" class=" form-control form-control-sm" [(ngModel)]="focus.email" placeholder="{{ 'Standard.Email' | translate }}" title="{{ 'Standard.Email' | translate }}">
          </td></tr>
          <tr><td>
            <input type="text" name="website" class=" form-control form-control-sm" [(ngModel)]="focus.website" [ngModelOptions]="{standalone: true}" placeholder="{{ 'Standard.Website' | translate }}" title="{{ 'Standard.Website' | translate }}">
          </td></tr>
        </tbody>
      </table>
      <div class="w-50 pl-5 column-end">
        <div SingleFileDrop class="w-100 text-center mb-3" style="height:5rem;" [(ngModel)]="focus.logo">
          <div *ngIf="!focus.logo">{{ 'Buttons.ChooseSingleImage' | translate }}</div>
          <img class="imgMax" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ focus.logo }}" alt="Department image" *ngIf="!!focus.logo" />
        </div>
        <div class="w-100 mb-3 column-end" *ngIf="!!data && !!data.departments.list">
          <label class="mb-1" for="departmentParentSelector">{{'Department.BelongsTo' | translate}}</label>
          <select id="departmentParentSelector" class="form-control form-control-sm secretSelector" [(ngModel)]="focus.departmentBelongToId">
            <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
            <option *ngFor="let y of data.departments.list" value="{{ y.departmentId }}" [disabled]="y.name == focus.name">{{y.name}}</option>
          </select>
        </div>
        <div class="w-100 column-end mb-3" *ngIf="notifications">
          <label class="mb-1" for="departmentNotificationSet">{{ 'Notifications.NotificationSet' | translate }}</label>
          <select class="form-control form-control-sm" id="departmentNotificationSet" [(ngModel)]="focus.notificationSetId">
            <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
            <option value="{{ x.id }}" *ngFor="let x of notifications">{{ x.name }}</option>
          </select>
        </div>
        <div class="w-100 flex-end" style="font-size:.8rem;" *ngIf="has_GoogleMap">
          <div class="flex-end mr-3">
            <div class="custom-control custom-checkbox ml-3 ">
              <input type="checkbox" [(ngModel)]="focus.showOnMap" class="custom-control-input" id="showOnMapSwitch">
              <label class="custom-control-label" for="showOnMapSwitch"></label>
            </div>
            <div>{{ 'OurLocations.ShowOnMap' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 mt-3 flex-end">
      <button class="btn btn-sm btn-success" (click)="contentEdit(focus)">{{ 'Buttons.Save' | translate }}</button>
    </div>
  </div>
</div>

<!--Ops and Maintenence Categories-->
<div class="row mt-3" *ngIf="data.view == 'opMainteneceCategories'">
  <div class="col-6">
    <input class="form-control mt-3 mb-3" type="text" [(ngModel)]="data.opsMaintenenceCategories.search" (keyup)="data.opsMaintenenceCategories.filter()" style="width:30rem;" placeholder="{{ 'Standard.Search' | translate }}" />
    <div>
      <div class="cursor-pointer" (click)="data.opsMaintenenceCategories.refocusBranch(null)">{{ 'Settings.Categories' | translate }}</div>
      <div class="ml-3" id="test" *ngIf="data.opsMaintenenceCategories.tree">
        <app-ops-and-maintain-tree [elementId]="'test'" [data]="data.opsMaintenenceCategories.tree"
                                   [search]="data.opsMaintenenceCategories.search"
                                   [selectable]="false"
                                   [editable]="true"
                                   (bubble)="dvChildEvent($event)">
        </app-ops-and-maintain-tree>
      </div>
    </div>
  </div>
  <div class="col-6">
    <div class="row mb-3">
      <div class="col-12 mb-3 d-flex">
        <div>{{ 'Standard.Folder' | translate }}</div>
        <input class="form-control form-control-sm ml-3" type="text" [(ngModel)]="data.opsMaintenenceCategories.focusCat.name" *ngIf="data.opsMaintenenceCategories.focusCat" style="width:max-content;" />
        <button class="btn btn-success btn-sm m-0 ml-2"
                (click)="dvChildEvent({type:'catRename', id: data.opsMaintenenceCategories.focusCat.id, name:data.opsMaintenenceCategories.focusCat.name, parentId: data.opsMaintenenceCategories.focusCat.parentId})"
                *ngIf="data.opsMaintenenceCategories.focusCat">
          {{ 'Buttons.Save' | translate }}
        </button>
        <button class="btn btn-danger btn-sm m-0 ml-2" [hidden]="data.opsMaintenenceCategories.deleteHide(data.opsMaintenenceCategories.focusCat)" (click)="deletionObject = data.opsMaintenenceCategories.focusCat; data.opsMaintenenceCategories.deleteType = 'cat'" data-toggle="modal" data-target="#deletionModal"><span><i class="fas fa-trash-alt"></i></span></button>
      </div>
      <div class="col-12 d-flex align-items-center">
        <input type="text" class="form-control form-control-sm" [(ngModel)]="data.opsMaintenenceCategories.newCat" style="width:25rem;" />
        <button class="btn btn-success btn-sm m-0 ml-2" [disabled]="!data.opsMaintenenceCategories.newCat" (click)="createDVFolder()"><span><i class="fas fa-plus-circle"></i></span> <span> {{ 'Categories.NewSubcategory' | translate }}</span></button>
      </div>
    </div>
    <div class="row" *ngIf="data.opsMaintenenceCategories.focusId">
      <div class="col-12">
        <table aria-label="Operations and maintenance categories">
          <thead>
              <th class="w-50">{{ 'Word.Text' | translate }}</th>
              <th>{{ 'Property.PropertyCost' | translate }}</th>
              <th>{{ 'Property.Subscription' | translate }}</th>
              <th>{{ 'Property.CommonCost' | translate}}</th>
              <th></th>
          </thead>
          <tbody>
            <tr *ngFor="let x of data.opsMaintenenceCategories.focusItems">
              <td><input class="form-control form-control-sm" type="text" [(ngModel)]="x.data.text" (change)="updateAccountPlan(x)" /></td>
              <td><input class="form-control form-control-sm" type="text" [(ngModel)]="x.data.propertyCost" (change)="updateAccountPlan(x)" /></td>
              <td><input class="form-control form-control-sm" type="text" [(ngModel)]="x.data.subscription" (change)="updateAccountPlan(x)" /></td>
              <td><input class="form-control form-control-sm" type="text" [(ngModel)]="x.data.commonCost" (change)="updateAccountPlan(x)" /></td>
              <td>
                <button class="btn-danger btn-sm m0 ml-2" (click)="deletionObject = x; data.opsMaintenenceCategories.deleteType = 'item'" data-toggle="modal" data-target="#deletionModal" style="border:none!important;"><i class="fas fa-trash-alt"></i></button>
              </td>
            </tr>
            <tr>
              <td><input class="form-control form-control-sm" type="text" [(ngModel)]="data.opsMaintenenceCategories.newItem.data.text" /></td>
              <td><input class="form-control form-control-sm" type="text" [(ngModel)]="data.opsMaintenenceCategories.newItem.data.propertyCost" /></td>
              <td><input class="form-control form-control-sm" type="text" [(ngModel)]="data.opsMaintenenceCategories.newItem.data.subscription" /></td>
              <td><input class="form-control form-control-sm" type="text" [(ngModel)]="data.opsMaintenenceCategories.newItem.data.commonCost" /></td>
              <td><button class="btn btn-success btn-sm m-0 ml-2" [disabled]="!data.opsMaintenenceCategories.newItem.data.text" (click)="createDVItem()"><span><i class="fas fa-plus-circle"></i></span> <span> {{ 'Buttons.CreateNew' | translate }}</span></button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!--Offer Rejections-->
<div class="row mt-3" *ngIf="data.view == 'offerRejections'">
  <div class="col-6">
    <div class="listItem d-flex align-items-center" *ngFor="let x of data.offerRejections.list">
      <div class="col-8 textItem">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.text" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<!--Skills-->
<div class="row mt-3" *ngIf="data.view == 'skills'">
  <div class="col-6">
    <div class="listItem d-flex align-items-center" *ngFor="let x of data.skills.list">
      <div class="col-8 textItem">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<!--Procurements-->
<div class="row mt-3" *ngIf="data.view == 'offerProcurements'">
  <div class="col-6">
    <div class="listItem d-flex align-items-center transition" *ngFor="let x of data.offerProcurements.list; let i = index" [ngStyle]="{'order':x.sort}">
      <div class="col-1 listIcon" (click)="iconChanger = x" data-toggle="modal" data-target="#iconChangerModal"><i [ngClass]="x.icon"></i></div>
      <div class="col-7 textItem">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <div></div>
        <div></div>
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<!--Enterprise-->
<div class="row mt-3" *ngIf="data.view == 'offerEnterprise'">
  <div class="col-6">
    <div class="listItem d-flex align-items-center transition" *ngFor="let x of data.offerEnterprise.list; let i = index" [ngStyle]="{'order':x.sort}">
      <div class="col-1 listIcon" (click)="iconChanger = x" data-toggle="modal" data-target="#iconChangerModal"><i [ngClass]="x.icon"></i></div>
      <div class="col-7 textItem">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <div></div>
        <div></div>
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<!--Standard Texts-->
<div class="row mt-3" *ngIf="data.view == 'standardTexts'">
  <div class="col-6">
    <div class="listItem listItem-tall d-flex align-items-center" *ngFor="let x of data.standardTexts.textList; let i = index">
      <div class="col textItem">
        <input class="seamlessTextEdit bold" type="text" [(ngModel)]="x.header" (change)="contentEdit(x)" [disabled]="data.standardTexts.isSaving" />
        <textarea class="seamlessTextEdit" [(ngModel)]="x.content" (change)="contentEdit(x)" [disabled]="data.standardTexts.isSaving"></textarea>
      </div>
      <div class="col-auto extraFunction">
        <button class="btn btn-sm btn-danger" (click)="data.standardTexts.toBeDeletedType = 'text'; data.standardTexts.toBeDeletedIndex = i;deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
  <div class="col-6">
    <div class="listItem listItem-tall d-flex align-items-center" *ngFor="let x of data.standardTexts.htmlList; let i = index">
      <div class="col textItem">
        <div class="d-flex justify-content-between">
          <input class="form-control" type="text" [(ngModel)]="x.header" (change)="contentEdit(x)" [disabled]="data.standardTexts.isSaving" />
        </div>
        <div>
          <editor [disabled]="data.standardTexts.isSaving" 
                  apiKey="ju9sza9zm91his4d6wz8hp4k6t6nx0hwzerok4dy2bjgm12i" 
                  [(ngModel)]="x.content" 
                  (onBlur)="contentEdit(x)" 
                  [attr.id]="i" 
                  [init]="{
                      plugins: 'advlist autolink lists link image charmap print preview anchor textcolor spellchecker code paste pagebreak table',
                      paste_as_text: true,
                      paste_auto_cleanup_on_paste : true,
                      paste_remove_styles: true,
                      paste_remove_styles_if_webkit: true,
                      paste_strip_class_attributes: true,
                      menubar: false,
                      toolbar: 'undo redo | fontsizeselect bold italic styleselect | bullist numlist link | table | code',
                      fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
                      table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                      table_advtab: false,
                      table_appearance_options: false,
                      branding: false,
                      statusbar:false,
                      contextmenu : 'spellchecker',
                      content_style: '.mce-content-body {font-size:10pt}',
                      style_formats: [
                          { title: 'Tekst', format: 'p' },
                          { title: 'Overskrift 1', format: 'h2' },
                          { title: 'Overskrift 2', format: 'h3' },
                          { title: 'Overskrift 3', format: 'h4' },
                          { title: 'Understreget', format: 'underline' },
                          { title: 'Gennemstreget', format: 'strikethrough' }
                        ],
                      default_link_target: '_blank',
                      browser_spellcheck: true,
                      link_assume_external_targets: true,
                      target_list: [{title: 'Jublo', value: '_blank'}]
                      }">
          </editor>
        </div>
      </div>
      <div class="col-auto extraFunction">
        <button class="btn btn-sm btn-danger" (click)="data.standardTexts.toBeDeletedType = 'html'; data.standardTexts.toBeDeletedIndex = i; deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<!-- Priorities -->
<div class="row mt-3" *ngIf="data.view == 'priorities'">
  <div class="col-12 col-md-6 d-flex flex-column" (dragleave)="priorityHoverId = null;priorityHoverPart = null">
    <div [attr.id]="x.priorityId" appItemDropper class="listItem listItem-tall d-flex align-items-center" draggable="true" (dragstart)="priorityDragged = x;" (itemDrop)="priorityDrop($event,i)" (hov)="priorityHover($event)" (dragEnd)="priorityDragEnd($event)" *ngFor="let x of data.priorities.list; let i = index" [ngClass]="{'hovTop': x.priorityId == priorityHoverId && priorityHoverPart == 'top', 'hovBot': x.priorityId == priorityHoverId && priorityHoverPart == 'bottom'}">
      <div class="col-8 textItem d-flex align-items-center">
        <span class="cursor-pointer"><i class="fas fa-bars"></i></span>
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
    <div *ngIf="priorityOrderChanged">
      <button class="btn btn-sm btn-success" (click)="savePriorityOrderChange()">{{ 'Buttons.Save' | translate }}</button>
    </div>
  </div>
</div>

<!-- Stages -->
<div class="row mt-3" *ngIf="data.view == 'caseStages'">
  <div class="col-12 col-md-6 d-flex flex-column">
    <div [attr.id]="x.stageId"
         class="listItem listItem-tall d-flex align-items-center"
         appItemDropper
         draggable="true"
         (dragstart)="objectDragged = x"
         (itemDrop)="objectDropped($event,i)"
         (hov)="objectHover($event)"
         *ngFor="let x of data.caseStages.list; let i = index"
         [ngClass]="{'hovTop': x.stageId == objectHoverId && objectHoverPart == 'top', 'hovBot': x.stageId == objectHoverId && objectHoverPart == 'bottom'}">
      <div class="col-10 textItem d-flex align-items-center">
        <span class="cursor-pointer mr-3"><i class="fas fa-bars"></i></span>
        <input class="mr-3" type="color" [(ngModel)]="x.color" (change)="contentEdit(x)">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
        <input class="seamlessTextEdit smallNumber" type="number" min="0" max="100" step="1" [(ngModel)]="x.probability" (change)="contentEdit(x)">
        <div class="d-flex" style="width:12rem">% {{ 'Standard.Probability' | translate }}</div>
      </div>
      <div class="col-2 extraFunction">
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<div class="row mt-3" *ngIf="data.view == 'assetCategories'">
  <div class="col-6">
    <div class="listItem d-flex align-items-center" *ngFor="let x of data.assetCategories.list">
      <div class="col-8 textItem">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<!-- Customer Tags -->
<div class="row mt-3" *ngIf="data.view == 'customerTags'">
  <div class="col-12 col-md-6 d-flex flex-column">
    <div [attr.id]="x.customerTagId" appItemDropper
         class="listItem listItem-tall d-flex align-items-center"
         draggable="true"
         (dragstart)="customerTagDragged = x;"
         (itemDrop)="customerTagDrop($event,i)"
         (hov)="customerTagHover($event)"
         (dragEnd)="customerTagDragEnd($event)"
         *ngFor="let x of data.customerTags.list; let i = index"
         [ngClass]="{'hovTop': x.customerTagId == customerTagHoverId && customerTagHoverPart == 'top', 'hovBot': x.customerTagId == customerTagHoverId && customerTagHoverPart == 'bottom'}">
      <div class="col-8 textItem d-flex align-items-center">
        <span class="cursor-pointer mr-3"><i class="fas fa-bars"></i></span>
        <input class="mr-3" type="color" [(ngModel)]="x.color" (change)="contentEdit(x)">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
    <div *ngIf="customerTagOrderChanged">
      <button class="btn btn-sm btn-success" (click)="saveCustomerTagOrderChange()">{{ 'Buttons.Save' | translate }}</button>
    </div>
  </div>
</div>

<!-- Case Tags -->
<div class="row mt-3" *ngIf="data.view == 'caseTags'">
  <div class="col-12 col-md-6 d-flex flex-column">
    <div [attr.id]="x.id"  class="listItem listItem-tall d-flex align-items-center" *ngFor="let x of data.caseTags.list; let i = index">
      <div class="col-8 textItem d-flex align-items-center">
        <span class="cursor-pointer mr-3"><i class="fas fa-bars"></i></span>
        <input class="mr-3" type="color" [(ngModel)]="x.color" (change)="contentEdit(x)">
        <input class="seamlessTextEdit" type="text" [(ngModel)]="x.name" (change)="contentEdit(x)" />
      </div>
      <div class="col-4 extraFunction">
        <button class="btn btn-sm btn-danger" (click)="deletionObject = x" data-toggle="modal" data-target="#deletionModal">X</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="objectOrderChanged">
  <button class="btn btn-sm btn-success" (click)="saveOrderChange()">{{ 'Buttons.Save' | translate }}</button>
</div>

<!--Shared Modals-->
<div id="iconChangerModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      <div class="modal-body" *ngIf="iconChanger != null">
        <app-icon-selector [(icon)]="iconChanger.icon"></app-icon-selector>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success" (click)="contentEdit(iconChanger)" data-dismiss="modal">{{ 'Word.Change' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div id="deletionModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      <div class="modal-body">{{ 'Standard.DeletePrompt' | translate}}?</div>
      <div class="modal-footer">
        <button class="btn btn-danger" (click)="deleter(deletionObject)" data-dismiss="modal">{{ 'Buttons.Delete' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Create Asset type/model -->
<div class="modal fade" id="newAssetModelType" tabindex="-1" role="dialog" aria-labelledby="newAssetModelTypeLabel" aria-hidden="true" *ngIf="newHeatingModel">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title" id="newAssetModelTypeLabel" *ngIf="model">{{ 'Buttons.AddAssetModel' | translate }}</h5>
        <h5 class="modal-title" id="newAssetModelTypeLabel" *ngIf="modelType">{{ 'Buttons.AddAssetType' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      <div class="modal-body p-3" *ngIf="model">
        <div *ngIf="!!data.assetModelTypes && data.assetModelTypes.length == 0">
          {{ 'Standard.HeatingModelNoTypesText' | translate }}
        </div>
        <div class="form-group" *ngIf="!!assetModel && !!data.assetModelTypes && data.assetModelTypes.length > 0">
          <div class="row">
            <div class="col-6 col-md-3">
              <label for="assetCategorySelctor">{{ 'Standard.Category' | translate }}</label>
              <select id="assetCategorySelctor" class="form-control" [(ngModel)]="assetModel.category.id">
                <option [value]="''">{{ 'Standard.Choose' | translate }}</option>
                <option [value]="x.id" *ngFor="let x of data.assetCategories.list">{{ x.name | translate }}</option>
              </select>
            </div>
            <div class="col-6 col-md-3">
              <label for="assetModelName">{{ 'Standard.Name' | translate }}</label>
              <input type="text" class="form-control" id="assetModelName" [(ngModel)]="assetModel.name" placeholder="Model A">
            </div>
            <div class="col-6 col-md-3">
              <label for="assetTypeSelctor">{{ 'Standard.Type' | translate }}</label>
              <select id="assetTypeSelctor" class="form-control" [(ngModel)]="assetModel.type.id">
                <option [value]="''">{{ 'Standard.Choose' | translate }}</option>
                <option [value]="x.id" *ngFor="let x of data.assetModelTypes">{{ x.name }}</option>
              </select>
            </div>
            <div class="col-6 col-md-3">
              <label for="assetTypeSelctor">{{ 'Standard.AttachesTo' | translate }}</label>
              <select multiple id="assetTypeSelctor" class="custom-select" [(ngModel)]="assetModel.parents" [size]="subAssetSize">
                <option [value]="[]">{{ 'Standard.NoneChosen' | translate }}</option>
                <option [value]="x.id" *ngFor="let x of data.assetModels">{{ x.model.modelName }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body p-3" *ngIf="modelType">
        <div class="form-group" *ngIf="!!assetModelType">
          <label for="assetTypeName">{{ 'Standard.Type' | translate }}</label>
          <input type="text" class="form-control" id="assetTypeName" [(ngModel)]="assetModelType.name" placeholder="{{ 'Standard.GasAirWater' | translate }}">
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between p-3">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="createAssetModel()" *ngIf="model && !!assetModel" [disabled]="assetModel.type.id != '' && !assetModel.name">{{ 'Buttons.Create' | translate }}</button>
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="createAssetModelType('')" *ngIf="modelType && !!assetModelType" [disabled]="!assetModelType.name">{{ 'Buttons.Create' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Asset type/model -->
<div class="modal fade" id="editAssetModelType" tabindex="-1" role="dialog" aria-labelledby="editAssetModelTypeLabel" aria-hidden="true" *ngIf="editHeatingModel">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title" id="editAssetModelTypeLabel" *ngIf="model">{{ 'Standard.EditAssetModel' | translate }}</h5>
        <h5 class="modal-title" id="editAssetModelTypeLabel" *ngIf="modelType">{{ 'Standard.EditAssetType' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      <div class="modal-body p-3" *ngIf="model">
        <div *ngIf="!!assetModel && !!data.assetModelTypes && data.assetModelTypes.length > 0">
          <div class="form-group">
            <div class="row">
              <div class="col-6 col-md-3">
                <label for="assetCategorySelctor">{{ 'Standard.Category' | translate }}</label>
                <select id="assetCategorySelctor" class="form-control" [(ngModel)]="assetModel.model.categoryId">
                  <option [value]="''">{{ 'Standard.Choose' | translate }}</option>
                  <option [value]="x.id" *ngFor="let x of data.assetCategories.list">{{ x.name | translate }}</option>
                </select>
              </div>
              <div class="col-6 col-md-3">
                <label for="assetModelName">{{ 'Standard.Name' | translate }}</label>
                <input type="text" class="form-control" id="assetModelName" [(ngModel)]="assetModel.model.modelName" placeholder="Model A">
              </div>
              <div class="col-6 col-md-3">
                <label for="assetTypeSelctor">{{ 'Standard.Type' | translate }}</label>
                <select id="assetTypeSelctor" class="form-control" [(ngModel)]="assetModel.type.id">
                  <option [value]="''">{{ 'Standard.Choose' | translate }}</option>
                  <option [value]="x.id" *ngFor="let x of data.assetModelTypes">{{ x.name }}</option>
                </select>
              </div>
              <div class="col-6 col-md-3">
                <label for="assetTypeSelctor">{{ 'Standard.AttachesTo' | translate }}</label>
                <select multiple id="assetTypeSelctor" class="custom-select" [(ngModel)]="assetModel.model.parents" [size]="subAssetSize">
                  <option [value]="[]">{{ 'Standard.NoneChosen' | translate }}</option>
                  <option [value]="x.id" *ngFor="let x of showMatchingParentModels(assetModel)" [selected]="findParentModels(assetModel.model, x.id)">{{ x.model.modelName }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body p-3" *ngIf="modelType">
        <div class="form-group" *ngIf="!!assetModelType">
          <label for="assetTypeName">{{ 'Standard.AssetType' | translate }}</label>
          <input type="text" class="form-control" id="assetTypeName" [(ngModel)]="assetModelType.name" placeholder="{{ 'Standard.GasAirWater' | translate }}">
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between p-3">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="editAssetModel()" *ngIf="model && !!assetModel" [disabled]="!assetModel.type.id && !assetModel.name">{{ 'Buttons.SaveExit' | translate }}</button>
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="editAssetModelType()" *ngIf="modelType && !!assetModelType" [disabled]="!assetModelType.name">{{ 'Buttons.SaveExit' | translate }}</button>
      </div>
    </div>
  </div>
</div>